import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class MipsService {

  constructor(
    private http:HttpClient
  ) { }

  createScale(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/mips/createScale`, data) 
  }

  deleteScale(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/mips/deleteScale`, data)
  }

  editScale(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/mips/editScale`, data)
  }

  getScales():Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/mips/getScales`);
  }

  updateScale(data):Observable<any>{
    return this.http.put(`${environment.apiBaseUrl}/mips/updateInterpretation`, data);
  }

  getInterpretations():Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/mips/getInterpretations`);
  }

  updateQuestion(data):Observable<any>{
    return this.http.put(`${environment.apiBaseUrl}/mips/updateQuestion`, data);
  }

  createQuestion(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/mips/createQuestion`, data);
  }

  getQuestions():Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/mips/getQuestions`);
  }

  getReport(id):Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/mips/getReport?id=${id}`);
  }

  createReport(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/mips/createReport`, data);
  }

}
